import { render, staticRenderFns } from "./FiltersPreview.vue?vue&type=template&id=06ff3f9c&"
import script from "./FiltersPreview.vue?vue&type=script&lang=js&"
export * from "./FiltersPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports